var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { canvasToFile } from '@rad/components/inputs/aspect-ratio-cropper';
import { getMimeTypeFromFilename } from '@rad/utility/formatting';
// Large enough for the lightbox on a big screen; a phone's 12-megapixel original is several times
// the bytes for no visible gain.
const MAX_EDGE = 2560;
const loadImage = (file) => {
    const url = URL.createObjectURL(file);
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error('Failed to load image'));
        };
        img.src = url;
    });
};
/** The photo scaled down, whole and in its own proportions, so its longer side is at most
 *  MAX_EDGE; a photo already that small, or one the browser cannot draw, is returned as it is. */
export const fitPhoto = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const img = yield loadImage(file).catch(() => null);
    if (img === null)
        return file;
    const scale = MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight);
    if (scale >= 1)
        return file;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    if (ctx === null)
        return file;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvasToFile(canvas, file.name, getMimeTypeFromFilename(file.name));
});
/** The kinds of photo the app takes, as a file input's `accept` lists them. */
export const PHOTO_ACCEPT = 'image/png,image/jpeg,image/webp';
/** Whether a file, picked or dropped, is one of the photos the app takes. */
export const isPhotoFile = (file) => PHOTO_ACCEPT.split(',').includes(file.type);
